<template>
    <ion-tab-bar slot="bottom" mode="ios" v-if="!hideTabNavigation">
        <ion-fab style="margin-bottom: 30px" horizontal="center" translucent="true">
            <ion-fab-button @click="() => router.push('/menu')">
                <ion-label class="order-button">ORDER</ion-label>
            </ion-fab-button>
        </ion-fab>

        <ion-tab-button tab="home" :class="{ active: isActiveRoute('/') }" @click="() => router.push('/')">
            <ion-icon :icon="isActiveRoute('/') ? home : homeOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">HOME</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="deals" :class="{ active: isActiveRoute('/deals') }" @click="() => router.push('/deals')">
            <ion-icon :icon="isActiveRoute('/deals') ? pricetags : pricetagsOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">DEALS</ion-label>
        </ion-tab-button>

        <!-- Tab Spacer  -->
        <svg></svg>

        <ion-tab-button tab="rewards" :class="{ active: isActiveRoute('/rewards') }" @click="() => router.push('/rewards')">
            <ion-icon :icon="isActiveRoute('/rewards') ? star : starOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">REWARDS</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="Account" :class="{ active: isActiveRoute('/login') }" @click="() => (isLoggedIn ? router.push('/account') : router.replace('/login'))">
            <ion-icon :icon="isActiveRoute('/login') ? person : personOutline" class="nav-color"></ion-icon>
            <ion-label class="nav-color">ACCOUNT</ion-label>
        </ion-tab-button>
    </ion-tab-bar>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { IonIcon, IonLabel, IonTabBar, IonTabButton, IonFab, IonFabButton } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { home, homeOutline, pricetags, pricetagsOutline, person, personOutline, star, starOutline } from 'ionicons/icons';

export default defineComponent({
    components: {
        IonLabel,
        IonTabButton,
        IonTabBar,
        IonIcon,
        IonFab,
        IonFabButton,
    },
    methods: {
        isActiveRoute(path: string): boolean {
            return this.router.currentRoute.value.path == path;
        },
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        const isNative = computed(() => store.getters.isNative);
        const isLoggedIn = computed(() => store.getters.isLoggedIn);
        const hideTabNavigation = computed(() => router.currentRoute.value.meta?.hideTabNavigation);

        return {
            router,
            isNative,
            home,
            homeOutline,
            pricetags,
            pricetagsOutline,
            person,
            personOutline,
            star,
            starOutline,
            isLoggedIn,
            hideTabNavigation,
        };
    },
});
</script>

<style scoped>
.order-button {
    background-color: var(--ion-color-primary);
    color: var(--ion-color-light);
    font-weight: bold;
    font-size: 1.2em;
}
ion-tabs {
    contain: none;
}
ion-tab-bar {
    contain: none;
}
ion-fab-button {
    border: 7px solid var(--ion-color-light);
    border-radius: 50%;
    width: 90px;
    height: 90px;
}
svg {
    width: 102px;
    margin-top: 19px;
}
ion-icon {
    font-size: 2.3em;
}
.active {
    color: var(--ion-color-primary);
}
.nav-color {
    color: #707070;
}
</style>
